export const MAX_CART_ITEM_QUANTITY = 999;
